import { render, staticRenderFns } from "./commissions.vue?vue&type=template&id=a139b624"
import script from "./commissions.vue?vue&type=script&lang=js"
export * from "./commissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports